import { Avatar as AvatarUI, AvatarProps } from 'antd';
import * as React from 'react';

import AvatarSource from 'images/avatarPlaceholder.png';

const Avatar: React.FC<AvatarProps> = (props) => {
  return <AvatarUI {...props} src={AvatarSource} />;
};

export default Avatar;
